import React from 'react';
import DeleteObject from '../../common/poppers/DeleteObject';
import CorrectionRow from '../correction/CorrectionRow';
import ModifyCorrection from '../correction/ModifyCorrection'; 
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

export const cashActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Korrekció módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => "CORRECTION_FIX" === row.pettyCashType || "CORRECTION_MODIFY" === row.pettyCashType,
        actionComponent: (props, close) => <ModifyCorrection {...props} close={close} />
    },
    {
        divider: true,
        canShow: (row) => "CORRECTION_FIX" === row.pettyCashType || "CORRECTION_MODIFY" === row.pettyCashType,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Korrekció törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        canShow: (row) => "CORRECTION_FIX" === row.pettyCashType || "CORRECTION_MODIFY" === row.pettyCashType,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/correction'} comp={<CorrectionRow {...props} />} />
    },
]